import { ReactNode } from 'react';

import { Button, Stack } from '@mui/material';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Dialog from '@mui/material/Dialog';

import { DialogContentStyled } from './TableEditorDialog.styled';

type TableEditorDialogProps = {
    children: ReactNode;
    open: boolean;
    setOpen: (show: boolean) => void;
};

export const TableEditorDialog = (
    props: TableEditorDialogProps
): JSX.Element => {
    const { children, open, setOpen, ...rest } = props;

    return (
        <Dialog
            open={open}
            onClose={setOpen}
            PaperProps={{
                sx: {
                    maxWidth: 1200,
                },
            }}
            {...rest}
        >
            <ClickAwayListener onClickAway={() => setOpen(false)}>
                <DialogContentStyled
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        flex: '1 1',
                    }}
                    role="presentation"
                >
                    {children}

                    <Stack direction="row" justifyContent="flex-end" flex="1 1">
                        <Button
                            variant="text"
                            size="large"
                            onClick={() => setOpen(false)}
                            sx={{
                                alignSelf: 'flex-end',
                            }}
                        >
                            Закрыть
                        </Button>
                    </Stack>
                </DialogContentStyled>
            </ClickAwayListener>
        </Dialog>
    );
};
